import { useEffect, useState } from "react";
import { xc, errMsg } from "@/lib/xc";

export function useXC(acc, action, params = {}, enabled = true) {
  const [s, setS] = useState({ data: null, loading: true, error: null });
  const key = JSON.stringify(params);
  useEffect(() => {
    if (!acc || !enabled) return;
    let on = true;
    setS({ data: null, loading: true, error: null });
    xc(acc, action, params)
      .then((d) => on && setS({ data: d, loading: false, error: null }))
      .catch((e) => on && setS({ data: null, loading: false, error: errMsg(e) }));
    return () => {
      on = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [acc?.id, action, key, enabled]);
  return s;
}

export function useSlice(list, step = 120) {
  const [n, setN] = useState(step);
  useEffect(() => setN(step), [list, step]);
  const onScroll = (e) => {
    const t = e.currentTarget;
    if (t.scrollTop + t.clientHeight > t.scrollHeight - 500) setN((x) => Math.min(x + step, list.length));
  };
  const ensure = (i) => setN((x) => Math.max(x, i + 20));
  return [list.slice(0, n), onScroll, ensure];
}

export function useNow(ms = 30000) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(t);
  }, [ms]);
  return now;
}
